export const isCI = process.env.CI;
